/* AlphaTiming: taken from NestedForm gem and modified to handle AT super nested form pattern */

(function ($) {
    window.NestedFormEvents = function () {
        this.addFields = $.proxy(this.addFields, this);
        this.removeFields = $.proxy(this.removeFields, this);
        this.removeATFields = $.proxy(this.removeATFields, this); // added for AT Super Nested Form
        this.editFields = $.proxy(this.editFields, this); // added for AT Super Nested Form
        this.updateFields = $.proxy(this.updateFields, this); // added for AT Super Nested Form
        this.cancelFields = $.proxy(this.cancelFields, this); // added for AT Super Nested Form
        this.changedFields = $.proxy(this.changedFields, this);  // added for AT Super Nested Form
    };

    NestedFormEvents.prototype = {
        addFields: function (e) {
            // Setup
            let link = e.currentTarget;
            let assoc = $(link).data('association');                // Name of child
            let blueprint = $('#' + $(link).data('blueprint-id'));
            let content = blueprint.data('blueprint');                // Fields template

            // Make the context correct by replacing <parents> with the generated ID
            // of each of the parent objects
            let context = ($(link).closest('.fields').closestChild('input, textarea, select').eq(0).attr('name') || '').replace(new RegExp('\[[a-z_]+\]$'), '');

            // context will be something like this for a brand new form:
            // project[tasks_attributes][1255929127459][assignments_attributes][1255929128105]
            // or for an edit form:
            // project[tasks_attributes][0][assignments_attributes][1]
            if (context) {
                let parentNames = context.match(/[a-z_]+_attributes(?=\]\[(new_)?\d+\])/g) || [];
                let parentIds = context.match(/[0-9]+/g) || [];

                for (let i = 0; i < parentNames.length; i++) {
                    // RS: fix bug with deeply nested forms not rewriting ids correctly
                    if (parentIds[i] && parentIds[i] !== "0") {
                        content = content.replace(
                            new RegExp('(_' + parentNames[i] + ')_.+?_', 'g'),
                            '$1_' + parentIds[i] + '_');

                        content = content.replace(
                            new RegExp('(\\[' + parentNames[i] + '\\])\\[.+?\\]', 'g'),
                            '$1[' + parentIds[i] + ']');
                    }
                }
            }

            // Make a unique ID for the new child
            let regexp = new RegExp('new_' + assoc, 'g');
            let new_id = this.newId();
            content = $.trim(content.replace(regexp, new_id));

            let field = this.insertFields(content, assoc, link);
            // bubble up event upto document (through form)
            field
                .trigger({type: 'nested:fieldAdded', field: field})
                .trigger({type: 'nested:fieldAdded:' + assoc, field: field});

            let at_nested_fields_wrapper = $(link).closest('[data-at-nested-fields-for-wrapper]')
            if (at_nested_fields_wrapper.length) {
                // we want to show the edit component and the save and cancel buttons
                // also want to hide the edit button
                field.find("[data-at-nf-edit]").show()
                field.find("[data-at-nf-view]").hide();

                // if nested-components class div exists, display as block to put buttons to bottom of nested form
                field.find('div.nested-components').css('display', 'block');

                let at_nested_fields_controls = field.find("[data-at-nf-controls]");

                at_nested_fields_controls.find(".remove_nested_fields").hide();
                at_nested_fields_controls.find(".edit_nested_fields").hide();
                at_nested_fields_controls.find(".update_nested_fields").show();
                at_nested_fields_controls.find(".cancel_nested_fields").show();
            }

            return false;
        },
        newId: function () {
            return new Date().getTime();
        },
        insertFields: function (content, assoc, link) {
            let target = $(link).data('target');
            if (target) {
                return $(content).appendTo($(target));
            } else {
                return $(content).insertBefore(link);
            }
        },
        removeATFields: function (e) {
          let $link = $(e.currentTarget),
              assoc = $link.data('association'), // Name of child to be removed
              at_nested_fields = $link.closest('[data-at-nested-fields-for-control]'),
              new_button = $link.closest('[data-at-nested-fields-for-wrapper]').find(".add_nested_fields"),
              hiddenField = $link.prev('input[type=hidden]'),
              field = $link.closest('.fields');

          hiddenField.val('1');
          at_nested_fields.hide();
          new_button.show();

          field
            .trigger({type: 'nested:fieldRemoved', field: field})
            .trigger({type: 'nested:fieldRemoved:' + assoc, field: field});
          return false;
        },
        removeFields: function (e) {
            let $link = $(e.currentTarget),
                assoc = $link.data('association'), // Name of child to be removed
                hiddenField = $link.prev('input[type=hidden]'),
                field = $link.closest('.fields');

            hiddenField.val('1');
            field.hide();

            field
                .trigger({type: 'nested:fieldRemoved', field: field})
                .trigger({type: 'nested:fieldRemoved:' + assoc, field: field});
            return false;
        },
        // Added for At Super Nested Form
        editFields: function (e) {
            // Added for At Super Nested Form
            let $link = $(e.currentTarget);

            let at_nested_fields = $link.closest('[data-at-nested-fields-for-control]')
            let at_nested_fields_edit = at_nested_fields.find('[data-at-nf-edit]')
            let at_nested_fields_view = at_nested_fields.find('[data-at-nf-view]')
            let at_nested_fields_controls = at_nested_fields.find('[data-at-nf-controls]')

            let edit_button = at_nested_fields_controls.find(".edit_nested_fields");
            let update_button = at_nested_fields_controls.find(".update_nested_fields");
            let cancel_button = at_nested_fields_controls.find(".cancel_nested_fields");

            // 1. hide the view component & edit button
            at_nested_fields_view.hide();
            edit_button.hide();

            // 2. show the edit component & update & cancel buttons
            at_nested_fields_edit.show();
            update_button.show();
            cancel_button.show();

            // 3. display nested-components as block if present, to put buttons at bottom
            at_nested_fields.find('div.nested-components').css('display', 'block');

            return false;
        },
        updateFields: function (e) {
            let $link = $(e.currentTarget);
            let at_nested_fields = $link.closest('[data-at-nested-fields-for-control]')
            let at_nested_fields_edit = at_nested_fields.find('[data-at-nf-edit]')
            let at_nested_fields_view = at_nested_fields.find('[data-at-nf-view]')
            let at_nested_fields_controls = at_nested_fields.find('[data-at-nf-controls]')

            let edit_button = at_nested_fields_controls.find(".edit_nested_fields");
            let update_button = at_nested_fields_controls.find(".update_nested_fields");
            let cancel_button = at_nested_fields_controls.find(".cancel_nested_fields");
            let remove_button = at_nested_fields_controls.find(".remove_nested_fields");
            let new_button = $link.closest('[data-at-nested-fields-for-wrapper]').find(".add_nested_fields")

            // 1. copy over values to the view
            let select_boxes = at_nested_fields_edit.find('select[data-at-nf-update-field]')
            select_boxes.each(function (index, select_box) {
                let $select = $(select_box);
                let field_identifier = $select.data('at-nf-update-field');
                let value = $select.find('option:selected').text();
                at_nested_fields_view.find(`[data-at-nf-field="${field_identifier}"]`).text(value);
            })
            let inputs = at_nested_fields_edit.find('input[data-at-nf-update-field]')
            inputs.each(function (index, input) {
                let $input = $(input);
                let field_identifier = $input.data('at-nf-update-field');
                let value = $input.val()
                at_nested_fields_view.find(`[data-at-nf-field="${field_identifier}"]`).text(value);
            })

            // 2. hide the edit fields (don't disable them)
            at_nested_fields_edit.hide();

            // 3. hide Update and Cancel buttons
            update_button.hide();
            cancel_button.hide();

            // 4. show the view, show the edit, remove and new buttons
            at_nested_fields_view.show();
            edit_button.show();
            remove_button.show();
            new_button.show();

            // 5. ensure that at-nf-new-field is no longer set on the field
            //    this will ensure that the cancel button behaves as if you're just cancelling
            //    the changes to the field rather than removing the field from the form
            if (cancel_button.attr("data-at-nf-new-field")) {
                cancel_button.removeAttr("data-at-nf-new-field")
            }

            // 6. return nested-components to be display flex when fields have been updated
            at_nested_fields.find('div.nested-components').css('display', 'flex');

            return false;
        },
        // Added for At Super Nested Form
        cancelFields: function (e) {
            let $link = $(e.currentTarget);
            let at_nested_fields = $link.closest('[data-at-nested-fields-for-control]')
            let at_nested_fields_edit = at_nested_fields.find('[data-at-nf-edit]')
            let at_nested_fields_view = at_nested_fields.find('[data-at-nf-view]')
            let at_nested_fields_controls = at_nested_fields.find('[data-at-nf-controls]')

            let edit_button = at_nested_fields_controls.find(".edit_nested_fields");
            let update_button = at_nested_fields_controls.find(".update_nested_fields");
            let cancel_button = at_nested_fields_controls.find(".cancel_nested_fields");
            let new_button = $link.closest('[data-at-nested-fields-for-wrapper]').find(".add_nested_fields")

            if ($link.attr("data-at-nf-new-field")) {
                at_nested_fields.remove();
                new_button.show();
                return;
            }

            // 1. set any inputs back to their original values
            let select_boxes = at_nested_fields_edit.find('select[data-at-nf-original-value]')
            select_boxes.each(function (index, select_box) {
                let $select = $(select_box);
                let value = $select.data("at-nf-original-value");
                // console.log(`resetting select box back to original value: ${value}`);
                $select.val(value).change();
                // $select.find(`option[value=${value}]`).attr('selected','selected').change()
            })
            let inputs = at_nested_fields_edit.find('input[data-at-nf-original-value]')
            inputs.each(function (index, input) {
                let $input = $(input);
                let value = $input.data("at-nf-original-value");
                // console.log(`resetting input back to original value: ${value}`);
                $input.val(value);
            })

            // 2. hide the edit fields (don't disable them)
            at_nested_fields_edit.hide();

            // 3. hide Update and Cancel buttons
            update_button.hide();
            cancel_button.hide()

            // 4. show the view component & show the edit & new buttons
            at_nested_fields_view.show();
            edit_button.show();
            new_button.show();

            // 5. return nested-components to be display flex when fields have been updated
            at_nested_fields.find('div.nested-components').css('display', 'flex');

            return false;
        },
        changedFields: function (e) {
            // an input or select has changed within the context of an edit view of an Alpha Timing Super Nested Form
            let $elem = $(e.currentTarget);
            let value = $elem.val();
            $elem.attr("data-at-nf-original-value", value);
            value = $elem.data("at-nf-original-value")
        }
    };

    window.nestedFormEvents = new NestedFormEvents();
    $(document)
        .delegate('form a.add_nested_fields', 'click', nestedFormEvents.addFields)
        .delegate('form a.remove_nested_fields', 'click', nestedFormEvents.removeFields)
        .delegate('form a.remove_at_nested_fields', 'click', nestedFormEvents.removeATFields)
        .delegate('form a.edit_nested_fields', 'click', nestedFormEvents.editFields)
        .delegate('form a.update_nested_fields', 'click', nestedFormEvents.updateFields)
        .delegate('form a.cancel_nested_fields', 'click', nestedFormEvents.cancelFields)
        .delegate('form [data-at-nf-edit] input:not([data-at-nf-original-value]), form [data-at-nf-edit] select:not([data-at-nf-original-value])', 'focus', nestedFormEvents.changedFields);
})(jQuery);

// http://plugins.jquery.com/project/closestChild
/*
 * Copyright 2011, Tobias Lindig
 *
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 */
(function ($) {
    $.fn.closestChild = function (selector) {
        // breadth first search for the first matched node
        if (selector && selector != '') {
            let queue = [];
            queue.push(this);
            while (queue.length > 0) {
                let node = queue.shift();
                let children = node.children();
                for (let i = 0; i < children.length; ++i) {
                    let child = $(children[i]);
                    if (child.is(selector)) {
                        return child; //well, we found one
                    }
                    queue.push(child);
                }
            }
        }
        return $();//nothing found
    };
})(jQuery);
